<section class="auth-form">
  <h1>Forgot password</h1>
  <form [formGroup]="form" (ngSubmit)="submit()">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Email</mat-label>
      <input matInput formControlName="email" type="email" />
      <mat-error *ngIf="form.get('email')?.hasError('required')">Email is required</mat-error>
      <mat-error *ngIf="form.get('email')?.hasError('email')">Enter a valid email</mat-error>
    </mat-form-field>

    <div class="actions">
      <button mat-raised-button color="primary" type="submit">Send code</button>
      <a routerLink="/login" mat-button>Back to login</a>
    </div>

    <p class="info" *ngIf="info() as i">{{ i }}</p>
    <p class="error" *ngIf="error() as e">{{ e }}</p>
  </form>
</section>
